var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import MuiAlert from '@mui/material/Alert';
export default function Alert(_a) {
    var children = _a.children, pfVariant = _a.pfVariant, borderColor = _a.borderColor, backgroundColor = _a.backgroundColor, sx = _a.sx, severity = _a.severity, alertIconColor = _a.alertIconColor, props = __rest(_a, ["children", "pfVariant", "borderColor", "backgroundColor", "sx", "severity", "alertIconColor"]);
    var sxStyles = alertIconColor
        ? __assign(__assign({}, sx), { '& .MuiAlert-icon': {
                color: alertIconColor,
            } }) : sx;
    return (_jsx(MuiAlert, __assign({ variant: pfVariant, style: {
            border: "1px solid ".concat(borderColor),
            backgroundColor: backgroundColor,
        }, severity: severity, sx: __assign({ alignItems: 'center', borderRadius: '8px' }, sxStyles) }, props, { children: children })));
}
